module.exports = __webpack_public_path__ + "media/images/emblems/Jorat-Mezieres_Wappen-b575aaa588c4d7ffd4b6d7d8514becdf.svg";